import * as React from 'react';
import { Input } from '../../../components/Bootstrap';
import { CenterModel } from '../types';

interface DeliveryTextEditorProps {
  onChange(data: CenterModel);
  data: CenterModel;
}

export class DeliveryTextEditor extends React.Component<DeliveryTextEditorProps, {}> {
  onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { value } = e.target;
    this.props.onChange({
      ...this.props.data,
      deliveryText: value,
    });
  };

  render() {
    return (
      <div className='fulfillment-center-modal-textbox-wrapper'>
        <Input
          className='fulfillment-center-modal-textbox'
          onChange={this.onChange}
          value={this.props.data.deliveryText}
          rows={4}
          type='textarea'
        />
      </div>
    );
  }
}
